import stakingPools from "@/domain/limitedSaunaStaking/pools";
import token from "@/domain/limitedSaunaStaking/token";
import network from "@/domain/limitedSaunaStaking/network";
import rewardToken from "@/domain/limitedSaunaStaking/rewardToken";

const store = {
  namespaced: true,
  state: {
    pools: stakingPools.map((stakingPool, index) => {
      return {
        title: stakingPool.title,
        description: "No minimum",
        url: stakingPool.url,
        NETWORK: network.name,
        CHAIN_ID: network.chainIds[0],
        coinSymbol: token.name,
        mainCoinImage: null,
        smallerCoinImage: null,
        minDepositAmount: `${0}`,
        totalStakingTokens: `${10}`,
        stakeTokenAddress: token.contractAddress,
        stakeTokenSymbol: token.name,
        stakeTokenDecimals: token.decimals,
        rewardTokenAddress: rewardToken.contractAddress,
        rewardTokenSymbol: rewardToken.name,
        rewardTokenDecimals: rewardToken.decimals,
        stakeContractAddress: stakingPool.contractAddress,
        status: "ACTIVE",
        apr: 0,
        order: index + 1,
        isMaster: false,
        id: index + 1,
        createdAt: new Date(),
        updatedAt: new Date(),
        isFrozen: false,
        isFinished: false,
        withdrawConstrains: {
          lockType: 0,
          unlockFeeType: 0,
          unlockFee: `${0}`,
          withdrawInterval: 0,
        },
        harvestConstrains: {
          isLocked: false,
        },
        account: {
          earned: `${0}`,
          staked: `${0}`,
          isApproved: false,
          harvestableTime: new Date().getTime() / 1000,
          withdrawableTime: new Date().getTime() / 1000,
          registered: false,
          rewardLockedup: 0,
          earnedDescription: null,
          totalClaimableTokens: `${0}`,
          totalClaimableUsd: `${0}`,
          compoundStaked: `${0}`,
        },
        compoundCallFee: `${0}`,
        totalPendingCakeRewards: `${0}`,
        compoundWithdrawFeePeriodString: "3 days",
        totalShares: `${0}`,
      };
    }),
  },
  getters: {},
  mutations: {
    updatePools(state, payload) {
      state.pools = payload;
    },
    approvePool(state, payload) {
      state.pools[payload].account.isApproved = true;
    },
  },
  actions: {
    updatePools({ commit }, payload) {
      commit("updatePools", payload);
    },
    approvePool({ commit }, payload) {
      commit("approvePool", payload);
    },
  },
};

export default store;
